// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".share-list[data-v-9a81cf24]{align-items:center;display:flex;flex-direction:column;flex-wrap:wrap;gap:.5rem;justify-content:center;list-style:none;list-style-type:none;margin:0;padding:0}.share-list--icon-only[data-v-9a81cf24]{flex-direction:row}.share-heading[data-v-9a81cf24]{font-weight:700;line-height:1.5;margin-bottom:.5rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
